// API call to Netlify function for generating variations
export const generateVariations = async (phrases) => {
  try {
    const response = await fetch('/.netlify/functions/generate-variations', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ phrases })
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const variations = await response.json();
    return variations;
  } catch (error) {
    console.error('Error generating variations:', error);
    throw error;
  }
};